module.exports = __webpack_public_path__ + "static/media/returns.b5be56d0.svg";